import { useRef, useState } from "react";
import { toast } from "sonner";
import { Share2, MessageCircle, Download, Loader2, Instagram } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { PROMO } from "@/lib/jackpot";

const btn = "h-11 px-4 rounded-full text-sm font-bold inline-flex items-center justify-center gap-2 disabled:opacity-60 active:scale-[.98] transition-transform";

export function PromoShare({ player = true }) {
  const { user } = useAuth();
  const [fmt, setFmt] = useState("story");
  const [busy, setBusy] = useState(false);
  const cache = useRef({});
  const f = PROMO.find((p) => p.id === fmt);
  const link = `${window.location.origin}/registrieren${user?.referral_code ? `?ref=${user.referral_code}` : ""}`;
  const text = `Dreh mit beim JACKPOT ROULETTE der itzPlay Community – Donnerstag 15 Uhr bis Sonntag 23:59! 🎰 Ein Rad, ein gemeinsamer Jackpot. Mach mit über meinen Link: ${link}`;
  const getFile = async () => {
    if (!cache.current[fmt]) {
      const r = await fetch(f.src);
      if (!r.ok) throw new Error("load");
      cache.current[fmt] = new File([await r.blob()], f.file, { type: "video/mp4" });
    }
    return cache.current[fmt];
  };
  const share = async () => {
    navigator.clipboard?.writeText(text).catch(() => {});
    if (!navigator.share) return toast.info("Video teilen geht am besten auf dem Handy – speichere es, der Text mit Link ist kopiert!");
    setBusy(true);
    try {
      const file = await getFile();
      if (navigator.canShare?.({ files: [file] })) await navigator.share({ files: [file], text, title: "itzPlay Jackpot Roulette" });
      else await navigator.share({ text, url: link, title: "itzPlay Jackpot Roulette" });
    } catch (e) {
      if (e?.name === "NotAllowedError") toast("Video ist bereit – tippe nochmal auf „Teilen“ 📲");
      else if (e?.name !== "AbortError") toast.error("Teilen hat nicht geklappt – speichere das Video und teile es aus deiner Galerie");
    } finally { setBusy(false); }
  };
  const download = async () => {
    setBusy(true);
    try {
      const url = URL.createObjectURL(await getFile());
      Object.assign(document.createElement("a"), { href: url, download: f.file }).click();
      setTimeout(() => URL.revokeObjectURL(url), 4000);
      navigator.clipboard?.writeText(text).catch(() => {});
      toast.success("Video gespeichert – der Text mit Link ist kopiert, einfach bei Instagram einfügen!");
    } catch { toast.error("Das Video konnte gerade nicht geladen werden – bitte gleich nochmal versuchen"); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-4" data-testid="jr-promo-share">
      <div className="inline-flex p-1 rounded-full bg-white/10" role="tablist">
        {PROMO.map((p) => (
          <button key={p.id} role="tab" aria-selected={fmt === p.id} onClick={() => setFmt(p.id)} data-testid={`jr-promo-format-${p.id}`}
            className={`h-9 px-4 rounded-full text-xs font-extrabold transition-colors ${fmt === p.id ? "bg-amber-300 text-[#4a2a08]" : "text-white/70"}`}>{p.label}</button>
        ))}
      </div>
      <p className="text-xs text-white/60" data-testid="jr-promo-hint">Ideal für: {f.hint}</p>
      {player && <video key={f.src} src={f.src} poster={f.poster} controls playsInline preload="none" className={`block mx-auto ${f.ratio} rounded-2xl bg-black object-contain`} data-testid="jr-promo-player" />}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
        <button onClick={share} disabled={busy} data-testid="jr-promo-share-btn" className={`${btn} jr-spin-cta text-[#4a2a08]`}>{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Share2 className="w-4 h-4" />} {busy ? "Video wird geladen …" : "Teilen"}</button>
        <a href={`https://api.whatsapp.com/send?text=${encodeURIComponent(`${text}\n\n🎬 Video: ${window.location.origin}${f.src}`)}`} target="_blank" rel="noopener noreferrer" data-testid="jr-promo-whatsapp" className={`${btn} bg-emerald-500 text-white`}><MessageCircle className="w-4 h-4" /> WhatsApp</a>
        <button onClick={download} disabled={busy} data-testid="jr-promo-download" className={`${btn} bg-white/10 text-white ring-1 ring-white/15`}><Download className="w-4 h-4" /> Speichern</button>
      </div>
      <p className="text-xs text-white/55 flex gap-1.5"><Instagram className="w-4 h-4 shrink-0 text-pink-300" /> Instagram: Auf dem Handy „Teilen“ tippen und Instagram wählen – oder das Video speichern und in der App hochladen. Der Text mit deinem Einladungslink wird automatisch kopiert.</p>
    </div>
  );
}
